import type { AppFunction } from '@/models';

export const CAREPLAN_NNN_ENDPOINT = 'zorgplan-nnn';

export function isCareplanNnnFunction(appFunction: Pick<AppFunction, 'endpoint'> | null | undefined): boolean {
  return appFunction?.endpoint === CAREPLAN_NNN_ENDPOINT;
}
